<div class="login-container">
  <p-menu #userMenu [popup]="true" [appendTo]="'body'" [styleClass]="'dropdown-menu'" [model]="userMenuItems"></p-menu>
  <button type="button" pButton class="login-btn" (click)="userMenu.toggle($event)">
    <fa-icon [icon]="userIcon"></fa-icon>
  </button>
</div>
